import React from "react"
import { Player, BigPlayButton, ControlBar } from "video-react"
import { Button, Modal } from "react-bootstrap"
import { HiOutlineX } from "react-icons/hi"

interface VideoModalProps {
  video: Record<string, unknown> | null
  display: boolean
  close: () => void
}

const VideoModal = ({ video, display, close }: VideoModalProps) => {
  const player = React.useRef<HTMLElement>(null)

  if (!video) {
    return null
  }

  return (
    <Modal centered show={display} onHide={close}>
      <Button variant="link" className="video-modal-close-button" onClick={() => close()}>
        <HiOutlineX />
      </Button>
      <Modal.Body className="p-0">
        <Player ref={player} src={video.url as string} className="video-player" height={600} fluid={false}>
          <BigPlayButton position="center" />
          <ControlBar autoHide={false} />
        </Player>
      </Modal.Body>
    </Modal>
  )
}

export default VideoModal
